import { render, staticRenderFns } from "./DeviceUpdateModal.vue?vue&type=template&id=135a3c6c&scoped=true&"
import script from "./DeviceUpdateModal.vue?vue&type=script&lang=js&"
export * from "./DeviceUpdateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135a3c6c",
  null
  
)

export default component.exports